import c from "./KNSLenkerBlock.module.scss";
import knsLogo from "./images/kns-logo-small.webp";

export default function KNSLenkerBlock() {
	let links = [
		{t: "Bli medlem ", l: "https://vbmedia.no/seilas-medlem"},
		{t: "Kurs og seiltilbud", l: "https://vbmedia.no/seilas-kurs"},
		{t: "KNS Marina", l: "https://vbmedia.no/seilas-marina"},
		{t: "Regatta", l: "https://vbmedia.no/seilas-regatta"},
	];

	return <div className={[c.root, 'contentBlock'].join(' ')}>
		<img src={knsLogo} alt="KNS Logo" className={c.logo} />
		<div className={c.title}><i>Opplev</i> {`Kongelig
Norsk Seilforening`}</div>
		<div className={c.links}>
			{links.map((link, i) => <a key={i} href={link.l} target="_blank">{link.t}</a>)}
		</div>
	</div>
}